// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2GrXO","name":"ConsentHeader_name__3feqn","birthday":"ConsentHeader_birthday__3_ba6","skeleton":"ConsentHeader_skeleton__11Pxg"};